export class ObjectUtils {
  /**
   * Acesso a elementos em um object por um caminho indicado em uma string
   * 
   * Caso você tenha um objeto como o abaixo
   * ```json
   * {
   *  "pai": {
   *    "filho": []
   *  }
   * }
   * ```
   * e você deseja acessar `pai.filho` por meio dessa string, utilize essa função!
   * 
   * @param objeto objeto cujo qual deseja-se acessar um elemento
   * @param caminho caminho para acesso ao elemento indicado por ponto
   * 
   * @return Elemento indicado no caminho
   */
  static acessarValor(objeto: any, caminho: string): any {
    return caminho.split('.').reduce((o, k) => o && o[k], objeto);
  }

  /**
   * Popula um valor em um objeto baseado no caminho informado
   */
  static popular(objeto: any, valor: any, caminho: string): any {
    const partesCaminho = caminho.split(".");

    let parteObjeto = objeto;
    
    for (let passosRestantes = partesCaminho.length; passosRestantes > 0; passosRestantes--) {
      const parteCaminho = partesCaminho[partesCaminho.length - passosRestantes];

      const caminhoNaoConcluido = passosRestantes > 1 && parteObjeto[parteCaminho] === undefined;
      const limparObjeto = passosRestantes === 2 && valor === undefined;
      const finalDoCaminho = passosRestantes === 1;

      if (limparObjeto) {
        parteObjeto[parteCaminho] = null;
        break;

      } else if (caminhoNaoConcluido) {
        parteObjeto[parteCaminho] = {}

      } else if (finalDoCaminho) {
        parteObjeto[parteCaminho] = valor;
      }

      parteObjeto = parteObjeto[parteCaminho];
    }

    return objeto;
  }
}